import { useState } from 'react';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';

import { loadClients } from 'actions/appointments';
import { DefaultAvatar } from 'atoms/default-avatar';
import Icon from 'atoms/icon';
import Input from 'atoms/input';
import PetDetails from 'organisms/PetDetails';
import { isEmpty } from 'util';

export default function ClientSelect({ selectedClient, setSelectedClient }) {
  const dispatch = useDispatch();
  const [displaySearch, setDisplaySearch] = useState(false);
  const [search, setSearch] = useState('');
  const [debounceTimeout, setDebounceTimeout] = useState(null);
  const [searchOptions, setSearchOptions] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const closeSearch = () => {
    setDisplaySearch(false);
    setSearch('');
    setSearchOptions(null);
  };

  const handleSearch = (input) => {
    if (!input || input.length <= 1) setSearchOptions(null);
    setSearch(input);
    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
      setIsLoading(false);
    }
    if (input && input.length > 1) {
      setIsLoading(true);
      setSearchOptions(null);
      setDebounceTimeout(
        setTimeout(() => {
          dispatch(loadClients(input)).then(({ success, data }) => {
            if (success) {
              const clients = data?.data;
              const options = [];
              clients.forEach((client) => {
                const clientAnimals = client.animals;
                clientAnimals.forEach((animal) => {
                  options.push({
                    avatarUrls: animal.avatarUrls,
                    breed: animal.breed,
                    name: animal.name,
                    size: animal.size,
                    type: animal.type,
                    uuid: animal.uuid,
                    owner: {
                      firstName: client.firstName,
                      lastName: client.lastName,
                      payment: client.payment,
                      phone: client.phone,
                      uuid: client.uuid,
                    },
                  });
                });
              });
              setSearchOptions(options);
            }
            setIsLoading(false);
          });
        }, 500)
      );
    }
  };

  const renderList = () => {
    if (isLoading) return <p className="p13 pl-24">Loading...</p>;
    if (!searchOptions) return '';
    if (searchOptions && !searchOptions.length)
      return <p className="p13 pl-24">0 clients found</p>;
    if (searchOptions?.length) {
      return searchOptions.map((animal) => (
        <button
          key={animal.uuid}
          className="animal-option button-reset flex-row pt-12 pb-12 pl-24 pr-24"
          onClick={() => {
            setSelectedClient(animal);
            closeSearch();
          }}
        >
          <PetDetails animal={animal} user={animal?.owner} />
        </button>
      ));
    }
  };

  return (
    <div className="client-select-panel flex-column mb-12 border-light-purple radius-24">
      <button
        className="button-reset flex-row justify-between p-24"
        onClick={() => (displaySearch ? closeSearch() : setDisplaySearch(true))}
      >
        <div className="flex-row">
          {!isEmpty(selectedClient) ? (
            <PetDetails animal={selectedClient} user={selectedClient?.owner} />
          ) : (
            <>
              <DefaultAvatar size="small" className="mr-10" />
              <p className="f13 bold">Select client</p>
            </>
          )}
        </div>
        <Icon name="arrow-down" />
      </button>
      {displaySearch && (
        <div
          className={classNames(
            `client-select-options flex-column mb-12 pt-24 pb-12 border-light-purple radius-24`,
            !isEmpty(selectedClient) && 'selected-client'
          )}
        >
          <Input
            placeholder="Search client"
            icon="search"
            onChange={handleSearch}
            value={search}
            size="small"
            className="pb-12 pl-24 pr-24"
            autoFocus
          />
          <div>{renderList()}</div>
        </div>
      )}
    </div>
  );
}
